<template>
 
    <div class="text1">
       修改密码
       <div class="line"></div>
       <form :model="mima" class="flex-column-align" autocomplete="off">
            <input v-model="mima.passWord" type="text" placeholder="请输入原先密码" class="inputacc" autocomplete="new-password">
			<input v-model="mima.passWords" type="password" placeholder="请输入新密码" class="inputpass" autocomplete="new-password">
        </form>
        <p class="tips">*密码应包含大写英文+小写英文+数字</p>
        <el-button class="sure" @click="surechange">确认修改</el-button>
        <p class="resettext">若忘记新密码可找辅导员重置密码</p>
    </div>
   


</template>
<script>

export default {
    components: {
      
    },
    data() {
      return {
        mima:{}
      }
    },
    methods:{
      surechange(){
        // console.log(this.mima,'mima');
        const data = this.mima;
        this.mima = {}
        this.$emit("custom-event", data); // 触发自定义事件
      }
    }
  }
</script>
<style scoped>
.text1{
width: 100%;
font-size: 35px;
font-weight: 500;
letter-spacing: 0px;
line-height: 50.68px;
color: rgba(51, 51, 51, 1);
text-align: center;
}
.line{
width: 60px;
height: 8px;
opacity: 1;
border-radius: 50px;
background: rgba(69, 131, 250, 1);

text-align: center;
margin:0 auto;
}
.inputacc{
  padding-left: 20px;
width: 362px;
height: 55px;
opacity: 1;
border-radius: 27.5px;
background: rgba(219, 237, 255, 1);
margin-top: 64px;
}
.inputpass{
  padding-left: 20px;
width: 362px;
height: 55px;
opacity: 1;
border-radius: 27.5px;
background: rgba(219, 237, 255, 1);
margin-top: 32px;
}
.tips{

font-size: 16px;
font-weight: 500;
letter-spacing: 0px;
line-height: 23.17px;
color: rgba(143, 140, 140, 1);
text-align: center;
margin:0 auto;
margin-top: 15px;
}
.sure{

width: 362px;
height: 55px;
opacity: 1;
border-radius: 27.5px;
background: linear-gradient(182.83deg, rgba(75, 123, 248, 1) 0%, rgba(57, 145, 255, 1) 100%);

font-size: 30px;
font-weight: 500;
letter-spacing: 0px;
line-height: 30px;
color: rgba(255, 255, 255, 1);
text-align: center;
margin-top: 120px;

}
.resettext{

font-size: 15px;
font-weight: 400;
letter-spacing: 0px;
line-height: 21.72px;
color: rgba(151, 151, 151, 1);
text-align: center;
margin-top: 8px;

}
</style>